import React from "react";
import styles from "./GlassCard.module.scss";

interface GlassCardProps {
  image?: string;
  icon?: string; // SVG path
  iconViewBox?: string;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export const GlassCard: React.FC<GlassCardProps> = ({
  image,
  icon,
  iconViewBox = "0 0 24 24",
  title,
  children,
  className,
}) => {
  return (
    <div className={`${styles["glass-card"]} ${className || ""}`}>
      {image && (
        <div className={styles["image-container"]}>
          <img src={image} alt={title || "Card image"} />
        </div>
      )}
      {!image && icon && (
        <div className={styles["icon-container"]}>
          <svg width={80} height={80} viewBox={iconViewBox}>
            <path strokeWidth="0" d={icon} />
          </svg>
        </div>
      )}
      {title && <h3>{title}</h3>}
      <div className={styles["card-content"]}>{children}</div>
    </div>
  );
};
